import { render, staticRenderFns } from "./presaleCoupons.vue?vue&type=template&id=37ad156b&scoped=true"
import script from "./presaleCoupons.vue?vue&type=script&lang=js"
export * from "./presaleCoupons.vue?vue&type=script&lang=js"
import style0 from "./presaleCoupons.vue?vue&type=style&index=0&id=37ad156b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad156b",
  null
  
)

export default component.exports